export default __webpack_public_path__ + "alberta-shoppingcart-euro.810265a77e1083f196e3.svg";